import { Tooltip, IconButton, SxProps, Theme, useTheme } from "@mui/material";
import { useMatchDownMd } from "Common/Hooks";
import { HorizontalLineOutlined, KeyArrowLeftOutlined, KeyArrowRightOutlined } from "Icons/Icons";
import { useState } from "react";

interface ICollapseButton {
  isCollapsed: boolean;
  onClick?: () => void;
  sx?: SxProps<Theme>;
}

export const CollapseButton = ({ isCollapsed, onClick, sx }: ICollapseButton) => {
  const theme = useTheme();
  const [isHover, setIsHover] = useState<boolean>(false);
  const { matchDownMd } = useMatchDownMd();

  const getIcon = () => {
    if (isCollapsed) {
      return <KeyArrowRightOutlined />;
    } else if (matchDownMd || isHover) {
      return <KeyArrowLeftOutlined />;
    } else {
      return <HorizontalLineOutlined />;
    }
  };

  return (
    <Tooltip title={isCollapsed ? "Expand Sidebar" : "Collapse Sidebar"} arrow placement="right">
      <IconButton
        size="small"
        sx={{
          "& .MuiSvgIcon-root": {
            fontSize: "1rem",
            color: theme.palette.grey[600],
          },
          zIndex: 1300,
          "&:hover": {
            background: theme.palette.grey[100],
          },
          position: "absolute",
          ...sx,
        }}
        onClick={() => {
          if (onClick) onClick();
        }}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
      >
        {getIcon()}
      </IconButton>
    </Tooltip>
  );
};
